<form [formGroup]="getProductDetailForm()">
  <div class="p-4 pt-2">
    <div class="row border-bottom pb-2 mb-2">
      <div class="col-10 mogo-header-2 text-start">
        Products
      </div>
      @if(!isTimeBased || getProductList().controls.length === 0){
      <div class="col-2 text-md-end">
        <button class="btn btn-primary" [disabled]="lockdown" (click)="addProduct()">Add Product</button>
      </div>
      }
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col" class="col mogo-bold text-start">#</th>
          <th scope="col" class="col-2 mogo-bold w-20 text-start">Category</th>
          <th scope="col" class="col-2 mogo-bold text-start" colspan="2"></th>
          <th scope="col" class="col-8 mogo-bold w-60 text-start">Items</th>
        </tr>
      </thead>
      <tbody formArrayName="products">

        @if(getProductList() !== null && getProductList().controls.length > 0){
        @for(product of getProductList().controls; track $index){
        @let productIndex = $index;

        <tr [formGroupName]="$index">
          <th [ngClass]="productIndex === 0 ? 'pt-3' : ''" scope="row">
            @if(productIndex === 0){
            <div class="row">
              &nbsp;
            </div>
            }
            {{ $index + 1 }}
          </th>
          <td [ngClass]="productIndex === 0 ? 'pt-3' : ''">
            @if(productIndex === 0){
            <div class="row">
              &nbsp;
            </div>
            }
            @if(!isTimeBased || $index === 0 ){
            <ng-select [readonly]="lockdown" [items]="productCategories" bindLabel="name"
              formControlName="category" (change)="onProductCategoryChange($event, $index)" >
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="text-md-start">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
            }
          </td>
          <td [ngClass]="productIndex === 0 ? 'pt-3' : ''" colspan="2">
            @if(productIndex === 0){
            <div class="row">
              &nbsp;
            </div>
            }
              <button class="btn btn-danger" [disabled]="lockdown || productIndex === 0" (click)="removeProduct($index)"><ng-icon size="1em" name="bootstrapTrash"></ng-icon></button>&nbsp;
              <button class="btn btn-primary" [disabled]="lockdown" (click)="addItem($index)"><ng-icon size="1em" name="bootstrapPlusLg"></ng-icon></button>
          </td>
          <td formArrayName="items">
            @if(productIndex === 0){
            <div class="row pb-1">
              <div class="offset-3 col-2 mogo-bold"> Quantity </div>
              <div class="col-2 mogo-bold"> Weight (tonne) </div>
              <div class="col-2 mogo-bold"> Volume (M3) </div>
              <div class="col-2 mogo-bold"> DG Class </div>
            </div>
            }
            @if(getProductItems(productIndex) !== null && getProductItems(productIndex).controls.length > 0){
            @for(item of getProductItems(productIndex).controls; track $index)
            {
            <div class="row pb-1" [formGroupName]="$index">
              <div class="col-3">
                <input id="description-input" type="text" class="form-control" formControlName="description"
                  placeholder="Description" (change)="onProductItemLineChange('description', $event, productIndex, $index)"/>
              </div>
              <div class="col-2">
                <input id="quantity-input" type="number" class="form-control" formControlName="quantity"
                  placeholder="Quantity" inputmode="numeric" (change)="onProductItemLineChange('quantity', $event, productIndex, $index)"/>
              </div>
              <div class="col-2">
                <input id="weight-input" type="number" class="form-control" formControlName="weight"
                  placeholder="Weight" (change)="onProductItemLineChange('weight', $event, productIndex, $index)"/>
              </div>
              <div class="col-2">
                <input id="volumeM3-input" type="number" class="form-control" formControlName="volumeM3"
                  placeholder="VolumeM3" (change)="onProductItemLineChange('volumeM3', $event, productIndex, $index)"/>
              </div>
              <div class="col-2">
                <ng-select [readonly]="lockdown" [items]="dangerousProductCodes" bindLabel="name"
                formControlName="dangerousGoodsClass" (change)="onDangerousGoodsClassChange($event, productIndex, $index)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="text-md-start">
                    {{ item.alias }}
                  </div>
                </ng-template>
              </ng-select>
              </div>
              <div class="col-1">
                <button class="btn btn-danger" [disabled]="lockdown || $index === 0"
                  (click)="removeItem(productIndex, $index)"><ng-icon size="1em" name="bootstrapTrash"></ng-icon></button>
              </div>
            </div>
            }
            }
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
    @if(getProductList() !== null && getProductList().controls.length === 0){
    <div class="row mt-2">
      <div class="col-12">
        Currently no products added
      </div>
    </div>
    }
  </div>
</form>
